import { useState, useEffect } from 'react';

/**
 * Custom hook to fetch citation metrics from Semantic Scholar API
 * Automatically updates as your citations grow on Semantic Scholar
 */

// Your Semantic Scholar author ID
// https://www.semanticscholar.org/author/Mohammad-Sayem-Chowdhury/2293688177
const SEMANTIC_SCHOLAR_AUTHOR_ID = '2293688177';

export function useScholarMetrics(fallbackCitations = 40) {
  const [citations, setCitations] = useState(fallbackCitations);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const fetchMetrics = async () => {
      try {
        const response = await fetch(
          `https://api.semanticscholar.org/graph/v1/author/${SEMANTIC_SCHOLAR_AUTHOR_ID}?fields=citationCount`,
          { headers: { 'Accept': 'application/json' } }
        );

        if (!response.ok) {
          throw new Error('Failed to fetch metrics');
        }

        const data = await response.json();

        if (data.citationCount !== undefined && data.citationCount !== null) {
          setCitations(data.citationCount);
        }

        setIsLoading(false);
      } catch (err) {
        setIsLoading(false);
      }
    };

    fetchMetrics();
  }, [fallbackCitations]);

  return { citations, isLoading };
}

export default useScholarMetrics;
